export default __webpack_public_path__ + "bdf6b074a8ef6635c1975e1e429b62e1.png";